/**
 * Exit Popup Chatbot
 *
 * Wires up an embedded chatbot inside the #exit-intent-popup modal.
 * Reuses the WWChatConfig global set by the main chat widget enqueue.
 *
 * NOTE: WWChatConfig is injected by an inline script attached to the chat
 * widget (priority 120), which loads AFTER scripts.js. All config access
 * is therefore deferred until the popup is actually shown via Fancybox.
 */
(function ($) {
	'use strict';

	var initialized = false;
	var DEFAULT_RESPONSE_ICON_SRC = '/wp-content/themes/breeze/dist/images/response.png';

	// Listen for the exit popup opening via Fancybox
	$(document).on('afterShow.fb', function (_e, instance, slide) {
		var src = (slide && slide.src) || '';
		if (src !== '#exit-intent-popup') return;
		if (initialized) return;

		var popup = document.getElementById('exit-intent-popup');
		if (!popup || !popup.classList.contains('exit-popup-chatbot')) return;

		var config = window.WWChatConfig;
		if (!config || !config.api || !config.api.proxyUrl) return;

		initialized = true;
		init(popup, config);
	});

	function init(popup, config) {
		var messagesContainer = popup.querySelector('.exit-chatbot__messages');
		var textarea = popup.querySelector('.exit-chatbot__input textarea');
		var sendButton = popup.querySelector('.exit-chatbot__input button');
		var closeButton = popup.querySelector('.exit-chatbot__close');
		var header = popup.querySelector('.exit-chatbot__header');
		var launcherIcon = ((config.branding && config.branding.launcher) || '').trim();
		var responseIconSrc = launcherIcon || popup.getAttribute('data-response-icon') || DEFAULT_RESPONSE_ICON_SRC;
		if (!messagesContainer || !textarea || !sendButton) return;

		var STORAGE_KEY = 'ww_exit_chat_' + config.api.franchiseId;
		var sessionId = 'exit-' + (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substr(2));

		// Try to restore session
		try {
			var saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
			if (saved && saved.sessionId && (Date.now() - saved.timestamp) < 24 * 60 * 60 * 1000) {
				sessionId = saved.sessionId;
			} else {
				localStorage.removeItem(STORAGE_KEY);
			}
		} catch (e) {}

		function saveSession() {
			try {
				localStorage.setItem(STORAGE_KEY, JSON.stringify({
					sessionId: sessionId,
					timestamp: Date.now()
				}));
			} catch (e) {}
		}

		function parseMarkdown(text) {
			return text
				.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1" loading="lazy">')
				.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
				.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>')
				.replace(/\n/g, '<br>');
		}

		function createAvatar() {
			var avatar = document.createElement('div');
			avatar.className = 'exit-chatbot__avatar exit-chatbot__avatar--image';
			var img = document.createElement('img');
			img.src = responseIconSrc;
			img.alt = '';
			img.loading = 'lazy';
			img.setAttribute('aria-hidden', 'true');
			avatar.appendChild(img);
			return avatar;
		}

		function addMessage(text, isUser) {
			var row = document.createElement('div');
			row.className = 'exit-chatbot__row ' + (isUser ? 'exit-chatbot__row--user' : 'exit-chatbot__row--bot');

			if (!isUser) {
				row.appendChild(createAvatar());
			}

			var el = document.createElement('div');
			el.className = 'exit-chatbot__message ' + (isUser ? 'exit-chatbot__message--user' : 'exit-chatbot__message--bot');
			el.innerHTML = isUser ? text : parseMarkdown(text);
			row.appendChild(el);

			messagesContainer.appendChild(row);
			messagesContainer.scrollTop = messagesContainer.scrollHeight;
			return row;
		}

		function showTyping() {
			var row = document.createElement('div');
			row.className = 'exit-chatbot__row exit-chatbot__row--bot';

			row.appendChild(createAvatar());

			var el = document.createElement('div');
			el.className = 'exit-chatbot__typing';
			el.innerHTML = '<span></span><span></span><span></span>';
			row.appendChild(el);

			messagesContainer.appendChild(row);
			messagesContainer.scrollTop = messagesContainer.scrollHeight;
			return row;
		}

		function sendMessage(message) {
			addMessage(message, true);
			textarea.disabled = true;
			sendButton.disabled = true;

			var typingRow = showTyping();

			fetch(config.api.proxyUrl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					message: message,
					session_id: sessionId,
					mode: 'default'
				})
			})
			.then(function (response) { return response.json(); })
			.then(function (data) {
				typingRow.remove();
				addMessage(data.response, false);
				saveSession();
			})
			.catch(function () {
				typingRow.remove();
				addMessage('Sorry, there was an error. Please try again.', false);
			})
			.finally(function () {
				textarea.disabled = false;
				sendButton.disabled = false;
				textarea.focus();
				});
		}

		function playIntroSequence() {
			if (!header || header.dataset.introPlayed === 'true') return;

			setTimeout(function () {
				header.classList.add('is-intro-typing');
			}, 250);

			setTimeout(function () {
				header.classList.remove('is-intro-typing');
				header.classList.add('is-intro-ready');
				header.dataset.introPlayed = 'true';
			}, 1250);
		}

		playIntroSequence();

		// Send button
		sendButton.addEventListener('click', function () {
			var msg = textarea.value.trim();
			if (msg) {
				sendMessage(msg);
				textarea.value = '';
			}
		});

		// Enter to send
		textarea.addEventListener('keypress', function (e) {
			if (e.key === 'Enter' && !e.shiftKey) {
				e.preventDefault();
				var msg = textarea.value.trim();
				if (msg) {
					sendMessage(msg);
					textarea.value = '';
				}
			}
		});

		if (closeButton) {
			closeButton.addEventListener('click', function (e) {
				e.preventDefault();
				if ($.fancybox && $.fancybox.getInstance()) {
					$.fancybox.close(true);
				}
			});
		}
	}
})(jQuery);
